export const Sheet2 = {
  estadoEjecucion: [
    {id: 1, value: "Concluida"},
    {id: 2, value: "En cierre"},
    {id: 3, value: "En ejecución"},
    {id: 4, value: "Paralizada"},
    {id: 5, value: "Por iniciar"},
    {id: 6, value: "Rescindido"},
    {id: 7, value: "Finalizada"},
    {id: 8, value: "En cierre/Liquidacion"},
  ],
};
